<template>
	<div class="content" ref="scan" id="scan">
		<div class="modal" v-if="success">
			<div class="box">
				<img src="@/assets/img/tick.png" style="width: 100px; height: 100px">
				<h3 style="text-align: center;"><b>Check In ជោគជ័យ<br>{{check_in_data.client_card}}</b></h3>
				<h4 style="text-align: center;">
					<b>{{check_in_data.client_code}}</b><br>
					<b>{{check_in_data.client_name}}</b><br>
					<b>{{config.datelify(check_in_data.expiry_date)}}</b> ({{config.timelify(check_in_data.expiry_date)}})
				</h4>
			</div>
		</div>
		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">

				<md-card>
					<md-card-header data-background-color="purple">
						<h4 class="title">Check-In អតិថិជន</h4>
						<!-- <p class="category">{{$route.name}}</p> -->
					</md-card-header>
					<md-card-content>
						<loading v-if="!loaded" />
						<el-tabs v-model="tabName" v-if="loaded">
							<el-tab-pane label="Check-In តាមកាត" name="first"></el-tab-pane>
							<el-tab-pane label="Check-In តាមរយៈស្វែងរក" name="second"></el-tab-pane>
						</el-tabs>
						<div v-if="tabName == 'first' && loaded" style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
							<img src="@/assets/img/scan.jpg" style="max-width: 300px; opacity: 0.8;">
							<h3 v-if="start">សូមធ្វើការស្កេនកាតដើម្បី Check In</h3>
							<md-button class="md-raised md-primary" @click="start = true" v-if="!start">ចាប់ផ្តើម</md-button>
						</div>
						<div v-if="tabName == 'second'">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-40">
									<md-field>
										<label>ស្វែងរកតាមរយៈ លេខកូដ ឈ្មោះ លេខទូរស័ព្ទ ឬ លេខកាត</label>
										<md-input v-model="search.text" type="text"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-size-20">
									<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក
									</md-button>
								</div>
							</div>

							<md-table v-if="clientList.length > 0">
								<md-table-row>
									<md-table-head>ល.រ</md-table-head>
									<md-table-head>លេខកូដ</md-table-head>
									<md-table-head>អតិថិជន</md-table-head>
									<md-table-head>លេខកាត</md-table-head>
									<md-table-head>សុពលភាព</md-table-head>
									<md-table-head>សាខា</md-table-head>
									<md-table-head>សកម្មភាព</md-table-head>
								</md-table-row>

								<md-table-row v-for="(client, index) in clientList">
									<md-table-cell>{{ index + 1 }}</md-table-cell>
									<md-table-cell>
										<!-- <img src="@/assets/img/default-member.png" style="width: 34px; margin-right:5px"> -->
										<b>{{ client.code }}</b>
									</md-table-cell>
									<md-table-cell><b>{{ client.name }}<br>{{ client.phone }}</b></md-table-cell>
									<md-table-cell><b v-if="String(client.card).length >0">{{ client.card }}</b><b v-else>មិនមាន</b></md-table-cell>
									<md-table-cell>
										<b><template v-if="config.timelify(client.expiry_date) != 'មិនមានសុពលភាព'">
											<span class="green">{{config.expirydate(client.expiry_date)}}</span>
											({{config.timelify(client.expiry_date)}})
										</template>
											<span class="late" v-if="config.timelify(client.expiry_date) == 'មិនមានសុពលភាព'">មិនមានសុពលភាព</span></b>
									</md-table-cell>
									<md-table-cell><b>{{client.branch_name}}</b></md-table-cell>
									<md-table-cell>
										<md-button class="md-just-icon md-simple md-success" @click="check_in(client.hash)">
											<md-icon>verified_user</md-icon>
											<md-tooltip md-direction="top">Check in</md-tooltip>
										</md-button>

									</md-table-cell>
								</md-table-row>
							</md-table>
						</div>
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			// this.searchHandler();

		},
		mounted() {
			this.$barcodeScanner.init(this.scanned);
			this.$refs.scan.focus();
			setTimeout(() => {
				document.getElementById("scan").click();
			}, 1000)
		},
		data() {
			return {
				tabName: "first",
				loaded: true,
				success: false,
				fail: false,
				failMessage: "",
				start: false,
				search: {
					text: "",
					branch: ""
				},
				previous: "",
				check_in_data: {
					client_code: "",
					client_name: "",
					expiry_date: "",
					client_card: ""
				},
				clientList: [],

			}
		},
		beforeDestroy() {
			this.$barcodeScanner.destroy();
		},
		watch: {
			'client.branchArray': function (val) {
				if (String(this.client.branchArray).length > 5) {
					this.client.branch_id = this.client.branchArray.id;
				} else {
					this.client.branch_id = "";
				}
			},
			'client.packageArray': function (val) {
				if (String(this.client.packageArray).length > 5) {
					this.client.package_id = this.client.packageArray.id;
				} else {
					this.client.package_id = "";
				}
			}
		},
		methods: {
			scanned(barcode) {
				console.log(barcode);
				if(String(barcode).length === 9) {
					if(this.previous != barcode) {
						this.previous = barcode;
						this.check_in(barcode);
						setTimeout(() => {
							this.previous = ""
						}, 2000)
					}
				}
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/client/search", {
					text: this.search.text,
					branch: this.search.branch,
					offset: more ? this.clientList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.clientList = more ? this.clientList.concat(data.body.data) : data.body.data;
					// this.clientList = data.body.data;
				})
			},
			check_in(hash) {
				this.$http.post(this.config.api + "/admin/client/check_in", {
					hash: hash
				}).then(data => {
					if(data.body.status == "success") {
						this.check_in_data.client_code = data.body.data.code;
						this.check_in_data.client_name = data.body.data.name;
						this.check_in_data.client_card = data.body.data.card;
						this.check_in_data.expiry_date = data.body.data.expiry_date;
						this.clientList = [];
						this.tabName = "first";
						this.success = true;
						setTimeout(() => {
							this.success = false
						}, 3200)
					}
					// this.clientList = data.body.data;
				})
			}
		}
	}
</script>
<style scoped>
	.modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.5);
		z-index: 999;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.box {
		background-color: white;
		padding: 30px;
		border-radius: 15px;
		max-width: 380px;
		width: 100%;
		height: 100%;
		max-height: 380px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/CheckIn.vue